import { cx } from '@linaria/core';
import { Pm2Icon } from '@pm2/react-utils';
import { ribbon } from './atom.ribbon.style.js';
import { jsx } from 'react/jsx-runtime';

function Ribbon(props) {
  if (!props.ident) {
    return null;
  }
  return /*#__PURE__*/jsx("span", {
    className: cx(ribbon, props.className),
    "data-ribbon": true,
    children: /*#__PURE__*/jsx(Pm2Icon, {
      ident: props.ident,
      size: 20
    })
  });
}

export { Ribbon };
//# sourceMappingURL=atom.ribbon.js.map
